export default {
      id: "i-features-01-usage",
      viewBox: "0 0 22 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-features-01",
      toString: function () {
        return this.url;
      }
    }